import { useEffect, useState } from "react";
import { IAdjustmentConfig } from "../../../Interfaces/deltaHedgeAdjustment";
import {
  getAdjustmentConfig,
  setAdjustmentConfig,
} from "../../../Requests/deltaHedgeAdjustment";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import TextInput from "../../../Components/TextInput";
import Button from "../../../Components/Button";
import { toast } from "react-toastify";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";

interface IProps {
  onClose: () => void;
}

const AdjustmentConfig = ({ onClose }: IProps) => {
  const [formValues, setFormValues] = useState({} as IAdjustmentConfig);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getAdjustmentConfig()
      .then((resp) => {
        setFormValues(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const changeHandler = (name: string, value: any) => {
    const nameParts = name.split(".");
    setFormValues({
      ...formValues,
      [nameParts[0]]: {
        ...formValues[nameParts[0] as keyof IAdjustmentConfig],
        [nameParts[1]]: value,
      },
    });
  };

  const submitHandler = () => {
    setLoading(true);
    setAdjustmentConfig(formValues)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const getForm = (
    title: string,
    fieldName: Exclude<keyof IAdjustmentConfig, "buyBase" | "sellBase">
  ) => (
    <div className="grid grid-cols-5 gap-x-2 gap-y-3 w-full border-b border-gray-400 pb-3">
      <div className="font-bold">{title}</div>
      <div />
      <div />
      <div />
      <div />
      <TextInput
        label=" حداکثر گاما یک درصد شاخص"
        name={`${fieldName}.maxGama`}
        value={formValues[fieldName]?.maxGama?.toString()}
        onChange={changeHandler}
        // kind="percent"
        extraLabel
      />
      <TextInput
        label="حداقل بازده قفل روزانه(حالت تقویت)"
        name={`${fieldName}.dailyLock_Reinforcement`}
        value={formValues[fieldName]?.dailyLock_Reinforcement?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل بازده قفل روزانه (حالت خنثی)"
        name={`${fieldName}.dailyLock_Netural`}
        value={formValues[fieldName]?.dailyLock_Netural?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل بازده قفل روزانه (حالت تضعیف)"
        name={`${fieldName}.dailyLock_Weaken`}
        value={formValues[fieldName]?.dailyLock_Weaken?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="مرز حباب نرمال"
        name={`${fieldName}.normalBubble_Border`}
        value={formValues[fieldName]?.normalBubble_Border?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل قدر مطلق دلتا"
        name={`${fieldName}.min_delta`}
        value={formValues[fieldName]?.min_delta?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل حجم معاملاتی روز قبل"
        name={`${fieldName}.min_trade`}
        value={formValues[fieldName]?.min_trade?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل روز باقی مانده"
        name={`${fieldName}.minRemainingDays`}
        value={formValues[fieldName]?.minRemainingDays?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداکثر روز باقی مانده"
        name={`${fieldName}.maxRemainingDays`}
        value={formValues[fieldName]?.maxRemainingDays?.toString()}
        onChange={changeHandler}
        extraLabel
      />
    </div>
  );

  return (
    <div className="flex flex-col justify-center items-start gap-3 pb-3">
      {loading ? <FullScreenLoading /> : <></>}
      {getForm("خرید کال", "buyCall")}
      {getForm("فروش کال", "sellCall")}
      {getForm("خرید پوت", "buyPut")}
      {getForm("فروش پوت", "sellPut")}
      <div className="flex flex-row justify-start items-start gap-5">
        <div className="flex flex-col justify-start items-start gap-5">
          <div className="font-bold">خرید دارایی پایه</div>
          <TextInput
            label="حداکثر حباب نرمال خرید"
            name="buyBase.maxBubbleNormal"
            onChange={changeHandler}
            value={formValues.buyBase?.maxBubbleNormal?.toString()}
            extraLabel
          />
        </div>
        <div className="flex flex-col justify-start items-start gap-5">
          <div className="font-bold">فروش دارایی پایه</div>
          <TextInput
            label="حداقل حباب نرمال فروش"
            name="sellBase.minBubbleNormal"
            onChange={changeHandler}
            value={formValues.sellBase?.minBubbleNormal?.toString()}
            extraLabel
          />
        </div>
      </div>
      <div className="mr-auto w-24">
        <Button text="ثبت" onClick={submitHandler} variant="contained" />
      </div>
    </div>
  );
};

export default AdjustmentConfig;
